export default __webpack_public_path__ + "static/media/close.8c0db3c7.svg";